import React from 'react';
import { FaTrophy } from 'react-icons/fa';
import { useWalletBalance } from '../hooks/useWalletBalance';

export default function HighScore() {
  const { loading, error } = useWalletBalance();

  if (loading) {
    return (
      <div className="nes-container is-rounded bounty-display">
        <div className="bounty-display-content">
          <FaTrophy className="bounty-display-icon" />
          <div className="bounty-display-text">
            <div className="bounty-display-label">Current Bounty</div>
            <div className="bounty-display-value">Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="nes-container is-rounded bounty-display">
        <div className="bounty-display-content">
          <FaTrophy className="bounty-display-icon" />
          <div className="bounty-display-text">
            <div className="bounty-display-label">Current Bounty</div>
            <div className="bounty-display-value">Error loading bounty</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="nes-container is-rounded bounty-display">
      <div className="bounty-display-content">
        <FaTrophy className="bounty-display-icon" />
        <div className="bounty-display-text">
          <div className="bounty-display-label">Current Bounty</div>
          <div className="bounty-display-value">25M $BREK</div>
          <small>Round 3 - Earn $BREK and Refer Friends</small>
        </div>
      </div>
    </div>
  );
} 